<h2>{{'PAGES.INFO_DETAIL.ATTACHMENTS.TITLE' | translate}}</h2>

@for (attachment$ of attachments; track attachment$; let i = $index) {
  @if ((attachment$ | async); as attachment) {
    <div class="spacer"></div>
    <div class="attachments__attachment">
      <app-svg-icon
        class="icon"
        [src]="'icons/32/clip.svg'"
        [svgStyle]="{ 'width.px': '32', 'height.px': '32' }"
      ></app-svg-icon>
      @if (isBrowser) {
        <a class="button-text" target="_blank" href="{{cmsURL}}{{attachment?.attributes?.url}}">{{ attachment?.attributes?.name }} ({{ $safeNavigationMigration(attachment?.relationships?.field_media_document?.data?.attributes?.filesize) | fileSize }})</a>
      }
      @if (!isBrowser) {
        <a class="button-text" (click)="download(cmsURL+$safeNavigationMigration(attachment?.attributes?.url))">{{ attachment?.attributes?.name }} ({{ $safeNavigationMigration(attachment?.relationships?.field_media_document?.data?.attributes?.filesize) | fileSize }})</a>
      }
    </div>
  } @else {
    @if (i === 0) {
      <app-loading></app-loading>
    }
  }
}

<div class="spacer-2"></div>
